const TABS = {
  TODAY: 'today',
  EXPIRED: 'to_review',
  FUTURE: 'future',
  ALL: 'all',
};

export default TABS;
